import { GymTypes } from 'fitbeat.models';
import { ExerciseSelection } from '../../entities';
import { Exercise } from '../../entities/exercise/exercise';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { isStaticWorkout, STUDIO_ZONE_TO_INCLUDE_IN_STATIC_WORKOUTS } from './static-zone-helper';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class PreferredZoneFilter implements IExerciseSelectionFilter {
    public description: string = 'Return only exercises that are compatable with this zone';
    public name: string = 'PreferredZoneFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[],
                  workoutStartDate: Date,
                  gymType: GymTypes,
                  ): Exercise[] {

        const shouldIncludeStudioZoneForStaticWorkouts = isStaticWorkout(gymType, userWorkoutSettings);
        return inputExercises.filter((e) => {
            if (!e.definedZones) {
                return false;
            }
            if (e.definedZones.indexOf(exerciseSelection.zone) !== -1) {
                return true;
            }
            if (
                shouldIncludeStudioZoneForStaticWorkouts &&
                e.definedZones.includes(STUDIO_ZONE_TO_INCLUDE_IN_STATIC_WORKOUTS)) {
                return true;
            }
            return false;
        });
    }
}
